import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { offerAgreementsAPI } from "api/api/offerAgreementsApi/offerAgreementsApi";
import { GetAllMarathonAgreementsByMarathonIdParams, GetAllMarathonAgreementsByMarathonIdRes } from "api/api/offerAgreementsApi/types";

export const getAllMarathonAgreementsByMarathonId = createAsyncThunk<
  GetAllMarathonAgreementsByMarathonIdRes,
  GetAllMarathonAgreementsByMarathonIdParams
>(
  "offerAgreements/getAllMarathonAgreementsByMarathonId",
  async ({ ...params }, { rejectWithValue }) => {
    try {
      const data = await offerAgreementsAPI.getAllMarathonAgreementsByMarathonId(params);
      return data;
    } catch (error: unknown) {
      if (axios.isAxiosError(error)) {
        console.error("AxioError while getting all marathon agreements", error.response?.data);
        return rejectWithValue(error.response?.data || "Unknown error");
      }
      else {
        console.error("Error while getting all marathon agreements", error);
        return rejectWithValue(
          "Что-то пошло не так... Попробуйте обновить страницу"
        );
      }
    }
  })